<div class="docked-panels-chip-strip" role="tablist">
  @for (tab of fixedTabs(); track tab; let i = $index) {
    <button
      type="button"
      role="tab"
      class="docked-panels-chip docked-panels-chip-fixed"
      [class.is-active]="activeTabKey() === fixedKey(i)"
      [attr.aria-selected]="activeTabKey() === fixedKey(i)"
      (click)="setActive(fixedKey(i))"
    >
      <span class="docked-panels-chip-label">{{ tab.label() }}</span>
    </button>
  }

  @for (panel of dockedPanels(); track panel.key) {
    <div
      class="docked-panels-chip docked-panels-chip-docked"
      role="tab"
      [class.is-active]="activeTabKey() === panel.key"
      [class.is-just-auto-docked]="justAutoDockedKey() === panel.key"
      [attr.aria-selected]="activeTabKey() === panel.key"
      (click)="setActive(panel.key)"
    >
      @if (panel.dockTab?.icon; as chipIcon) {
        <i class="fas fa-{{ chipIcon }} docked-panels-chip-icon" aria-hidden="true"></i>
      }
      <span class="docked-panels-chip-label">{{ panel.dockTabLabel() || panel.key }}</span>
      @if (panel.lockable) {
        @if (panel.lockedTo(); as lockedTo) {
          <button
            eBtn
            size="xs"
            compact
            squared
            type="button"
            icon="lock"
            iconColor="primary"
            class="docked-panels-chip-action docked-panels-chip-lock is-locked"
            [tooltip]="unlockTooltip(lockedTo.label)"
            [attr.aria-label]="unlockTooltip(lockedTo.label)"
            (click)="handleToggleLock($event, panel)"
          ></button>
        } @else {
          @if (panel.lockCandidate(); as candidate) {
            <button
              eBtn
              size="xs"
              compact
              squared
              type="button"
              icon="lock-open"
              iconColor="primary-75"
              class="docked-panels-chip-action docked-panels-chip-lock"
              [tooltip]="lockTooltip(candidate.label)"
              [attr.aria-label]="lockTooltip(candidate.label)"
              (click)="handleToggleLock($event, panel)"
            ></button>
          }
        }
      }
      <button
        eBtn
        size="xs"
        compact
        squared
        type="button"
        icon="arrow-up-right-from-square"
        iconColor="primary-75"
        class="docked-panels-chip-action"
        tooltip="Losmaken"
        aria-label="Maak paneel los"
        (click)="handleUndock($event, panel)"
      ></button>
      <button
        eBtn
        size="xs"
        compact
        squared
        type="button"
        icon="xmark"
        iconColor="primary-75"
        class="docked-panels-chip-action"
        tooltip="Sluiten"
        aria-label="Sluit paneel"
        (click)="handleClose($event, panel)"
      ></button>
    </div>
  }
</div>

<div #content class="docked-panels-content">
  <div
    class="dock-area-fixed"
    [hidden]="!isFixedActive()"
    [class.is-side-by-side]="sideBySideFixedTabs() && fixedTabs().length > 1"
  >
    @for (tab of fixedTabs(); track tab; let i = $index) {
      <div
        class="dock-area-fixed-pane"
        [hidden]="!(sideBySideFixedTabs() || activeTabKey() === fixedKey(i))"
      >
        <ng-container [ngTemplateOutlet]="tab.template"></ng-container>
      </div>
    }
  </div>

  <!-- BELANGRIJK: alle gedockte panelen blijven gemount (enkel [hidden]).
       Met één outlet voor enkel de actieve tab (de oude opzet) werd het
       vorige paneel bij elke wissel afgebroken en het nieuwe from scratch
       herbouwd — inclusief constructor-werk zoals scope-loads, wat samen met
       de invalidatie-storm in HdGateInfoService.loadScopesForLang (zie de
       doc-comment daar) een voelbare wissel-delay gaf (gefixt 2026-09-22).
       Gemount houden maakt wisselen instant en bewaart paneel-state
       (toggles, geladen afbeeldingen); enkel de allereerste dock bouwt. -->

  @for (panel of dockedPanels(); track panel.key) {
    <div
      class="docked-panels-content-pane dock-area-panel-pane"
      [hidden]="activeTabKey() !== panel.key"
    >
      <ng-container
        *ngComponentOutlet="panel.component; injector: injectorForPanel(panel)"
      ></ng-container>
    </div>
  }
</div>
